import i18n from '@nextroll/ar-i18n';

interface NodeHeaderSectionHelpText {
    helpText: string;
    linkTo: string;
    linkText: string;
}

interface NodeHeaderSectionHelpTextMap {
    [key: string]: NodeHeaderSectionHelpText;
}

export const getNodeHeaderHelpText = (serviceTitle: string, workflowServiceEid: string): NodeHeaderSectionHelpText => {
    const helpTextMap: NodeHeaderSectionHelpTextMap = {
        SJPXZQ24N5CKDNLIRG8RFL: {
            helpText: i18n.gettext('Contacts can only be added to a Marketo static list. If you want to connect to a Smart List, use the "Member of List" filter to pull members from this static list.'),
            linkTo: 'https://help.rollworks.com/hc/articles/14220880203405',
            linkText: `${serviceTitle} ${i18n.gettext('Guide')}`,
        },
        DSKMNXSSHJEG7HEZGA8RFL: {
            helpText: i18n.gettext('A Contact entering this action will be added to the selected Marketo Smart Campaign. The campaign must include the “Campaign is Requested” trigger with the Source set to “Web Services API”.'),
            linkTo: 'https://help.rollworks.com/hc/articles/14220880203405',
            linkText: `${serviceTitle} ${i18n.gettext('Guide')}`,
        },
        UKILVJUO4VC73C22OZ8RFL: {
            helpText: i18n.gettext('Update or override existing fields in the matched Salesforce Contact or Lead. If you can\'t find the fields you need, you may contact your Salesforce administrator for access.'),
            linkTo: 'https://help.rollworks.com/hc/articles/14829224824973',
            linkText: `${serviceTitle} ${i18n.gettext('Guide')}`,
        },
        CSMCZ76U6RAQ5PE47K8RFL: {
            helpText: i18n.gettext('A Contact or Lead entering this action will be added as a Campaign Member to the selected Salesforce Campaign. You can update its "Member Status" in a Salesforce campaign. In cases where the enrolled contact or lead already exists in the campaign, this action will update its "Member Status".'),
            linkTo: 'https://help.rollworks.com/hc/articles/14829224824973',
            linkText: `${serviceTitle} ${i18n.gettext('Guide')}`,
        },
        '57RTMZMHIFGLNFGBSO8RFL': {
            helpText: i18n.gettext('A contact entering this action will be enrolled in the selected HubSpot Workflow. Using AdRoll ABM to trigger your HubSpot workflows allows you to coordinate your nurture email campaigns with advertising, to trigger internal notifications using AdRoll data, and more. This action does not create new contact records in HubSpot.'),
            linkTo: 'https://help.rollworks.com/hc/articles/14220872420877',
            linkText: `${serviceTitle} ${i18n.gettext('Guide')}`,
        }
    };

    return helpTextMap[workflowServiceEid];
};
